<template>
  <svg xmlns="http://www.w3.org/2000/svg" stroke="currentColor" viewBox="0 0 300 300" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="4">
    <path d="M105.3,23.3V5l128.6,64.6v206.3l-18.8-9.4M86.5,34.3V13.8l18.8,9.4,109.8,55.2v206.3l-20.3-10.2M194.7,88.7v206.3l-128.6-64.7V24.1l20.3,10.2,18.8,9.4,89.5,45ZM85.5,112.7l83.8,44.1M85.5,144.5l83.8,44.1M85.5,176l83.8,44.1M85.5,207.7l58.2,30.6M103.4,70.4v11.7l11.3,6.2v3l-11.3-6.2v11.8l-3.2-1.8v-11.8l-11.3-6.2v-3l11.3,6.2v-11.7l3.2,1.8h0Z" />
  </svg>
</template>
